import Generic from "./Generic";

const itemsList = ["bomb", "revive_crystal"];
export default class Item extends Generic {
  setup = async () => {
    const { items } = this.globalModels;

    for (let index in itemsList) {
      let item = itemsList[index];
      await this._register(`${index}`, {
        ...items[item],
        castShadow: false,
        receiveShadow: false,
      });
    }
    return this.models;
  };
}
